var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _path10, _g2, _path11, _g3, _path12, _g4, _path13, _g5, _path14, _g6, _path15, _g7, _path16, _g8, _path17, _g9, _path18, _g10, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrazilIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_480_15775",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1 0H0.9C0.402944 0 0 0.402944 0 0.9V17.1C0 17.5971 0.402944 18 0.9 18H23.1C23.5971 18 24 17.5971 24 17.1V0.9C24 0.402944 23.5971 0 23.1 0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_480_15775)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_480_15775",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V18H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_480_15775)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V18H24V0Z",
    fill: "#009933"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_480_15775",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 18
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V18H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_480_15775)"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9451 2.77832L21.0965 9.15592L11.8206 15.1287L2.85669 9.03229L11.9451 2.77832Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9451 2.77832L21.0965 9.15592L11.8206 15.1287L2.85669 9.03229L11.9451 2.77832Z",
    fill: "#FFD221"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9451 2.77832L21.0965 9.15592L11.8206 15.1287L2.85669 9.03229L11.9451 2.77832Z",
    fill: "url(#paint0_linear_480_15775)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 12.9004C14.0708 12.9004 15.7498 11.2215 15.7498 9.15039C15.7498 7.07932 14.0708 5.40039 11.9998 5.40039C9.92869 5.40039 8.24976 7.07932 8.24976 9.15039C8.24976 11.2215 9.92869 12.9004 11.9998 12.9004Z",
    fill: "#2E42A5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_480_15775",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 5,
    width: 8,
    height: 8
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 12.9004C14.0708 12.9004 15.7498 11.2215 15.7498 9.15039C15.7498 7.07932 14.0708 5.40039 11.9998 5.40039C9.92869 5.40039 8.24976 7.07932 8.24976 9.15039C8.24976 11.2215 9.92869 12.9004 11.9998 12.9004Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_480_15775)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.785 10.9275L10.6174 11.0156L10.6494 10.829L10.5139 10.6969L10.7012 10.6697L10.785 10.5L10.8687 10.6697L11.056 10.6969L10.9205 10.829L10.9525 11.0156L10.785 10.9275Z",
    fill: "#F7FCFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_480_15775",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 5,
    width: 8,
    height: 8
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 12.9004C14.0708 12.9004 15.7498 11.2215 15.7498 9.15039C15.7498 7.07932 14.0708 5.40039 11.9998 5.40039C9.92869 5.40039 8.24976 7.07932 8.24976 9.15039C8.24976 11.2215 9.92869 12.9004 11.9998 12.9004Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_480_15775)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.285 10.9275L12.1174 11.0156L12.1494 10.829L12.0139 10.6969L12.2012 10.6697L12.285 10.5L12.3687 10.6697L12.556 10.6969L12.4205 10.829L12.4525 11.0156L12.285 10.9275Z",
    fill: "#F7FCFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_480_15775",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 5,
    width: 8,
    height: 8
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 12.9004C14.0708 12.9004 15.7498 11.2215 15.7498 9.15039C15.7498 7.07932 14.0708 5.40039 11.9998 5.40039C9.92869 5.40039 8.24976 7.07932 8.24976 9.15039C8.24976 11.2215 9.92869 12.9004 11.9998 12.9004Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_480_15775)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.285 11.8279L12.1174 11.916L12.1494 11.7294L12.0139 11.5973L12.2012 11.5701L12.285 11.4004L12.3687 11.5701L12.556 11.5973L12.4205 11.7294L12.4525 11.916L12.285 11.8279Z",
    fill: "#F7FCFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_480_15775",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 5,
    width: 8,
    height: 8
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 12.9004C14.0708 12.9004 15.7498 11.2215 15.7498 9.15039C15.7498 7.07932 14.0708 5.40039 11.9998 5.40039C9.92869 5.40039 8.24976 7.07932 8.24976 9.15039C8.24976 11.2215 9.92869 12.9004 11.9998 12.9004Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_480_15775)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.535 8.6775L11.3674 8.76557L11.3994 8.57904L11.2639 8.44693L11.4512 8.41972L11.535 8.25L11.6187 8.41972L11.806 8.44693L11.6705 8.57904L11.7025 8.76557L11.535 8.6775Z",
    fill: "#F7FCFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_480_15775",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 5,
    width: 8,
    height: 8
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 12.9004C14.0708 12.9004 15.7498 11.2215 15.7498 9.15039C15.7498 7.07932 14.0708 5.40039 11.9998 5.40039C9.92869 5.40039 8.24976 7.07932 8.24976 9.15039C8.24976 11.2215 9.92869 12.9004 11.9998 12.9004Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_480_15775)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.535 10.1775L11.3674 10.2656L11.3994 10.079L11.2639 9.94693L11.4512 9.91972L11.535 9.75L11.6187 9.91972L11.806 9.94693L11.6705 10.079L11.7025 10.2656L11.535 10.1775Z",
    fill: "#F7FCFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_480_15775",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 5,
    width: 8,
    height: 8
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 12.9004C14.0708 12.9004 15.7498 11.2215 15.7498 9.15039C15.7498 7.07932 14.0708 5.40039 11.9998 5.40039C9.92869 5.40039 8.24976 7.07932 8.24976 9.15039C8.24976 11.2215 9.92869 12.9004 11.9998 12.9004Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_480_15775)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4849 9.4275L10.3174 9.51557L10.3494 9.32904L10.2139 9.19693L10.4012 9.16972L10.4849 9L10.5687 9.16972L10.756 9.19693L10.6204 9.32904L10.6524 9.51557L10.4849 9.4275Z",
    fill: "#F7FCFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_480_15775",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 5,
    width: 8,
    height: 8
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 12.9004C14.0708 12.9004 15.7498 11.2215 15.7498 9.15039C15.7498 7.07932 14.0708 5.40039 11.9998 5.40039C9.92869 5.40039 8.24976 7.07932 8.24976 9.15039C8.24976 11.2215 9.92869 12.9004 11.9998 12.9004Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_480_15775)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.43463 10.0281L9.26711 10.1162L9.2991 9.92962L9.16357 9.79752L9.35087 9.7703L9.43463 9.60059L9.51839 9.7703L9.70568 9.79752L9.57015 9.92962L9.60214 10.1162L9.43463 10.0281Z",
    fill: "#F7FCFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_480_15775",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 5,
    width: 8,
    height: 8
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 12.9004C14.0708 12.9004 15.7498 11.2215 15.7498 9.15039C15.7498 7.07932 14.0708 5.40039 11.9998 5.40039C9.92869 5.40039 8.24976 7.07932 8.24976 9.15039C8.24976 11.2215 9.92869 12.9004 11.9998 12.9004Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_480_15775)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8848 7.47828L12.7173 7.56635L12.7493 7.37982L12.6138 7.24771L12.8011 7.2205L12.8848 7.05078L12.9686 7.2205L13.1559 7.24771L13.0203 7.37982L13.0523 7.56635L12.8848 7.47828Z",
    fill: "#F7FCFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_480_15775",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 5,
    width: 8,
    height: 8
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 12.9004C14.0708 12.9004 15.7498 11.2215 15.7498 9.15039C15.7498 7.07932 14.0708 5.40039 11.9998 5.40039C9.92869 5.40039 8.24976 7.07932 8.24976 9.15039C8.24976 11.2215 9.92869 12.9004 11.9998 12.9004Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_480_15775)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.4436 8.24868L7.55639 6.75293C11.1548 7.02427 13.995 8.20745 16.0412 10.3121L14.9657 11.3577C13.1922 9.53355 10.6968 8.49399 7.4436 8.24868Z",
    fill: "#F7FCFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_480_15775",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 5,
    width: 8,
    height: 8
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 12.9004C14.0708 12.9004 15.7498 11.2215 15.7498 9.15039C15.7498 7.07932 14.0708 5.40039 11.9998 5.40039C9.92869 5.40039 8.24976 7.07932 8.24976 9.15039C8.24976 11.2215 9.92869 12.9004 11.9998 12.9004Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_480_15775)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.2168 7.95308L9.25543 7.58008C11.5752 7.82037 13.5648 8.70889 15.2185 10.2437L14.9634 10.5186C13.3699 9.03958 11.4564 8.18507 9.2168 7.95308Z",
    fill: "#009933"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_480_15775",
    x1: 11.9766,
    y1: 15.1287,
    x2: 11.9766,
    y2: 2.77832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE42"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrazilIcon);
export default __webpack_public_path__ + "static/media/BrazilIcon.4922e09c0476e1e3ea06976bded51016.svg";
export { ForwardRef as ReactComponent };